import React, { useMemo } from "react";

import isString from "lodash/isString";

import Avatar from "@src/multiCustodian/components/Avatar/Avatar";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaskActor.module.css";

type TaskActorPersonProps = {
  actorName: {
    first: string;
    last: string;
  };
};

type TaskActorGroupProps = {
  groupName: string;
};

type TaskActorProps = {
  avatarSrc?: string | null;
} & (TaskActorPersonProps | TaskActorGroupProps);

const TaskActor: React.FC<TaskActorProps> = (props) => {
  const name = "actorName" in props ? props.actorName : props.groupName;

  const actorName = useMemo(() => {
    if (isString(name)) {
      return { initials: " ", displayName: name };
    }

    const firstNameInitial = name.first.at(0);
    const lastNameInitial = name.last.at(0);
    const initials =
      firstNameInitial && lastNameInitial
        ? `${firstNameInitial}${lastNameInitial}`
        : undefined;

    return { initials, displayName: `${firstNameInitial!}. ${name.last}` };
  }, [name]);

  return (
    <div className={styles.container}>
      <Avatar
        className={styles.avatar}
        imageSource={props.avatarSrc}
        initials={actorName.initials}
      />
      <Text className={styles.name} variant="bodySmall" color="textSubtle">
        {actorName.displayName}
      </Text>
    </div>
  );
};

export default TaskActor;
